module.exports = __webpack_public_path__ + "media/site/images/team/alek@2x-3a6b90a7a6028043d911c14bfb1d09e1.png";